<sm-title-bar pageTitle="Promotion"></sm-title-bar>


<div *ngIf="loader" class="loader">
  <mat-spinner></mat-spinner>
</div>

<div
  *ngIf="!loader"
  class="stat-cards promotion row row-cols-md-2 row-cols-1 g-4"
>
  <div class="col">
    <mat-card>
      <mat-card-content>
        <h2 class="mb-0">Advertisers</h2>
        <p><small>All the companies and brands associated with us.</small></p>
        <h1>10</h1>
      </mat-card-content>
      <mat-card-actions class="text-end">
        <button
          mat-button
          [routerLink]="['/promotion', 'advertiser']"
        
        >
          View details
          <mat-icon class="material-icons-round"> arrow_forward </mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  <div class="col">
    <mat-card>
      <mat-card-content>
        <h2 class="mb-0">Admin post</h2>
        <p><small>Post and promotions done by admin.</small></p>
        <h1>{{ totalAdminPost }}</h1>
      </mat-card-content>
      <mat-card-actions class="text-end">
        <button
          mat-button
          [routerLink]="['/promotion', 'admin-post']"
          
        >
          View details
          <mat-icon class="material-icons-round"> arrow_forward </mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  <div class="col">
    <mat-card>
      <mat-card-content>
        <h2 class="mb-0">Business promotion</h2>
        <p>
          <small>Business promotions and endorsements done on demand.</small>
        </p>
        <h1>{{ totalBuisnessPromotion }}</h1>
      </mat-card-content>
      <mat-card-actions class="text-end">
        <button
          mat-button
          [routerLink]="['/promotion', 'business-promotion']"
    
        >
          View details
          <mat-icon class="material-icons-round"> arrow_forward </mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  <div class="col">
    <mat-card>
      <mat-card-content>
        <h2 class="mb-0">Targetted notification</h2>
        <p>
          <small>Notifications targetted for specific user or group.</small>
        </p>
        <h1>{{ totalTargetedList }}</h1>
      </mat-card-content>
      <mat-card-actions class="text-end">
        <button
          mat-button
          [routerLink]="['/promotion', 'target-notification']"
      
        >
          View details
          <mat-icon class="material-icons-round"> arrow_forward </mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  <div class="col">
    <mat-card>
      <mat-card-content>
        <h2 class="mb-0">Coupons</h2>
        <p>
          <small>Lorem ipsum dolor sit amet, consectetur adipisicing elit</small>
        </p>
        <h1>{{totalCouponsList}}</h1>
      </mat-card-content>
      <mat-card-actions class="text-end">
        <button
          mat-button
          [routerLink]="['/promotion', 'coupons']"
      
        >
          View details
          <mat-icon class="material-icons-round"> arrow_forward </mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
